import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppContext } from "../functions/ContextAPI";

/**
 * ProtectedRoute component - Restricts access to authenticated users only
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {React.ReactNode} - Protected content or redirect to login
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  // Check for authentication token directly from localStorage
  const authToken = localStorage.getItem("authToken");
  const representativeUser = localStorage.getItem("representativeUser");

  const isAuthenticated = authToken && representativeUser;

  if (!isAuthenticated) {
    // Redirect to login page, but save the location they were trying to access
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;